import { render } from "./ConsentLink.vue?vue&type=template&id=d7777142&scoped=true"
import script from "./ConsentLink.vue?vue&type=script&lang=js"
export * from "./ConsentLink.vue?vue&type=script&lang=js"

import "./ConsentLink.vue?vue&type=style&index=0&id=d7777142&lang=scss"
import "./ConsentLink.vue?vue&type=style&index=1&id=d7777142&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7777142"]])

export default __exports__